import { render, staticRenderFns } from "./AdminTaxonomies.vue?vue&type=template&id=699916e5"
import script from "./AdminTaxonomies.vue?vue&type=script&lang=js"
export * from "./AdminTaxonomies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699916e5')) {
      api.createRecord('699916e5', component.options)
    } else {
      api.reload('699916e5', component.options)
    }
    module.hot.accept("./AdminTaxonomies.vue?vue&type=template&id=699916e5", function () {
      api.rerender('699916e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminTaxonomies.vue"
export default component.exports